const rawBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();

export const API_BASE_URL = rawBaseUrl.replace(/\/+$/, '');
